import * as i0 from '@angular/core';
import { Pipe, Injectable, NgModule } from '@angular/core';

class Ng2SearchPipe {
    /**
       * @param items object from array
       * @param term term's search
       * @param excludes array of strings which will ignored during search
       */
    transform(items, term, excludes = []) {
        if (!term || !items)
            return items;
        return Ng2SearchPipe.filter(items, term, excludes);
    }
    /**
     *
     * @param items List of items to filter
     * @param term  a string term to compare with every property of the list
     * @param excludes List of keys which will be ignored during search
     *
     */
    static filter(items, term, excludes) {
        const toCompare = term.toLowerCase();
        function checkInside(item, term) {
            if (typeof item === "string" && item.toString().toLowerCase().includes(toCompare)) {
                return true;
            }
            for (let property in item) {
                if (item[property] === null || item[property] == undefined || excludes.includes(property)) {
                    continue;
                }
                if (typeof item[property] === 'object') {
                    if (checkInside(item[property], term)) {
                        return true;
                    }
                }
                else if (item[property].toString().toLowerCase().includes(toCompare)) {
                    return true;
                }
            }
            return false;
        }
        return items.filter(function (item) {
            return checkInside(item, term);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipe, isStandalone: true, name: "filter", pure: false }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipe }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filter',
                    pure: false,
                    standalone: true,
                }]
        }, {
            type: Injectable
        }] });

class Ng2SearchPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipeModule, imports: [Ng2SearchPipe], exports: [Ng2SearchPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: Ng2SearchPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [Ng2SearchPipe],
                    exports: [Ng2SearchPipe]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Ng2SearchPipe, Ng2SearchPipeModule };
